var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 234.058,
    height: 219.625,
    viewBox: "0 0 234.058 219.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11397",
    "data-name": "Path 11397",
    d: "M15806.479,13498.023c-30.164,21.312-150.421,147.658-25.6,181.147,98.859,26.522,138.523,9.133,138.523,9.133a72.188,72.188,0,0,0,19.508-7.638c17.583-10.1,36.128-37.089-1.24-118.708C15879.829,13435.612,15836.643,13476.712,15806.479,13498.023Z",
    transform: "translate(-15725.329 -13474.276)",
    fill: "#caddeb",
    opacity: 0.48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.8cc2dbd8.svg";
export { ForwardRef as ReactComponent };